import { render } from "./FormKonversiSatuan.vue?vue&type=template&id=86631b1a"
import script from "./FormKonversiSatuan.vue?vue&type=script&lang=js"
export * from "./FormKonversiSatuan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__